import { render, staticRenderFns } from "./OtherPartySurvey.vue?vue&type=template&id=3a47e409"
import script from "./OtherPartySurvey.vue?vue&type=script&lang=ts"
export * from "./OtherPartySurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports